import * as _ from 'lodash-es';
import { AdminCompany } from '../model/adminCompany';
import { AdminCostcenterBuilder } from '../builders/adminCostcenter-builder';
import { AdminPaymethodBuilder } from '../builders/adminPaymethod-builder';
import { AdminCompanyList } from '../model/adminCompany-list';
import { CompanyNote } from '../model/companyNote';
export class AdminCompanyBuilder {
    static buildAdminCompany(data) {
        let company = new AdminCompany();
        company.id = data.id;
        company.name = data.name;
        company.nif = data.nif;
        company.address = data.address;
        company.zip = data.zip;
        company.state = data.state;
        company.city = data.city;
        company.active = data.active;
        company.country = data.country;
        company.date_modified = data.date_modified;
        company.date_register = data.date_register;
        company.monthly_invoice = data.monthly_invoice;
        company.invoice_per_costcenter = data.invoice_per_costcenter;
        company.billing_send_invoice_copy = data.billing_send_invoice_copy;
        company.discount = data.discount;
        company.billing_email = data.billing_email;
        company.rappel_multiplier = data.rappel_multiplier;
        company.source = data.source;
        company.invoice_profiles = data.invoice_profiles;
        company.block_premium = data.block_premium;
        company.block_premium_for_some_users = data.block_premium_for_some_users;
        company.block_washes = data.block_washes;
        company.send_all_notification_to_admins = data.send_all_notification_to_admins;
        company.enable_booking_records = data.enable_booking_records;
        company.id_user = data.id_user;
        company.user_alias = data.user_alias;
        company.costcenters = _.map(data.costcenters, (costcenter) => {
            return AdminCostcenterBuilder.buildAdminCostcenter(costcenter);
        });
        company.paymethods = _.map(data.paymethods, (paymethod) => {
            return AdminPaymethodBuilder.buildAdminPaymethod(paymethod);
        });
        company.notes = _.map(data.notes, (notes) => {
            return this.buildCompanyNote(notes);
        });
        return company;
    }
    static buildCompanyNote(data) {
        const note = new CompanyNote();
        note.id_user = data.id_user;
        note.id_company = data.id_company;
        note.date_created = data.date_created;
        note.body = data.body;
        note.id = data.id;
        note.user_alias = data.user_alias;
        return note;
    }
    static buildAdminCompanyList(data) {
        const adminCompany = new AdminCompanyList();
        adminCompany.page = data.page;
        adminCompany.pagination = data.pagination;
        adminCompany.total = data.total;
        adminCompany.totalPages = data.totalPages;
        adminCompany.companies = _.map(data.companies, (adminCompany) => {
            return this.buildAdminCompany(adminCompany);
        });
        return adminCompany;
    }
}
//# sourceMappingURL=adminCompany-builder.js.map